import { ShopToClubOverlayConfig } from '../types/types';
import { PAGE_VIEW } from './useShouldShowShopToClub';
import { getS2cBannerFontFromCountry } from 'Helpers/classes';

export const useShopToClubOverlayConfig = (): ShopToClubOverlayConfig =>
    // TODO Use appShell properties to get real configuration
    // Current is based on settings provided in confluence.
    ({
        mobileImage:
            'https://static.westwingnow.de/image/upload/q_90/cms/Shop2Club%20overlay/Shop2Club%20Overlay%20DE/S2C_overlay_badge_20_DE.png',
        mobileDelayInSeconds: 1,
        expirationInDays: 14,
        isDismissible: true,
        isUndismissibleFromOutsideClick: false,
        pageViewLimit: PAGE_VIEW.secondPageView,
        getS2cBannerFontFromCountry,
    });
